import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Card from '../../Components/Containers/Card';
import { useStatusBarColour } from '../../Components/Mobile';
import { classNames } from '../../Services/helpers';
import OnboardingProvider, { useOnboarding } from './OnboardingProvider';
import Progress from './Components/Progress';
import IntroStep from './Steps/IntroStep';
import ServicesStep from './Steps/ServicesStep';
import BusinessNameStep from './Steps/BusinessNameStep';
import WebsiteStep from './Steps/WebsiteStep';
import ContactDetailsStep from './Steps/ContactDetailsStep';
import FirstCustomerStep from './Steps/FirstCustomerStep';
import AccountStep from './Steps/AccountStep';

const stepComponents = {
    intro: IntroStep,
    services: ServicesStep,
    businessName: BusinessNameStep,
    website: WebsiteStep,
    contact: ContactDetailsStep,
    customer: FirstCustomerStep,
    account: AccountStep,
};

const Onboarding = () => {
    return <OnboardingProvider>
        <Wizard />
    </OnboardingProvider>;
};

const Wizard = () => {
    const {step, stepIndex, setVoucherCode} = useOnboarding();
    const {code} = useParams();

    // Safe here: the page renders inside the layout's <Mobile> provider
    useStatusBarColour('#F8F9FA');

    // Capture the voucher code from /register/:code into the draft so it
    // survives leaving and resuming the wizard
    useEffect(() => {
        if (code) {
            setVoucherCode(code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    const StepComponent = stepComponents[step] ?? ServicesStep;
    const showProgress = stepIndex >= 2;

    return <Card noPadding className="w-full max-h-full min-h-0 flex flex-col">
        {showProgress && <div className="px-5 pt-5 shrink-0">
            <Progress />
        </div>}
        <div className={classNames(
            'flex-1 min-h-0 overflow-y-auto px-5 pb-5',
            showProgress ? '' : 'pt-5',
        )}>
            <StepComponent />
        </div>
    </Card>;
};

export default Onboarding;
